import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setCanEdit,
  setReferee,
  setRefereeStatus,
} from "../../../../store/refereeSlice";
import { checkRefereeStatus } from "../../Helpers/common";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secoundTypography: {
    color: "#4B4B4B",
    fontWeight: 600,
    marginRight: 20,
  },
  proposalName: {
    fontWeight: 500,
    cursor: "pointer",
  },
}));

export default function MyReviews(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { proposalReferees } = props;
  const tableHeaders = [
    { label: "Proposal ID", size: "35%" },
    { label: "Title", size: "40%" },
    { label: "Program", size: "25%" },
  ];

  const proposalSelected = (referee) => {
    const refereeStatus = checkRefereeStatus(referee);
    dispatch(
      setReferee({
        id: referee.itemID,
        idName: referee.proposalIdNumber,
        title: referee.proposalTitle,
        program: referee.proposalProgramtypeName,
      })
    );
    dispatch(setRefereeStatus(refereeStatus));
    dispatch(setCanEdit(false));
    history.push("./detailedevaluation");
  };

  return (
    <>
      <Typography fontWeight={600} color="#4B4B4B">
        My Reviews
      </Typography>
      <Divider />
      <Table
        stickyHeader
        className={classes.table}
        size="small"
        aria-label="caption table"
      >
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell
                className={classes.tableCell}
                key={header.label}
                align="left"
                style={{ width: header.size }}
              >
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {proposalReferees.map((proposalReferee) => (
            <TableRow key={proposalReferee.itemID}>
              <TableCell
                className={classes.proposalName}
                onClick={() => proposalSelected(proposalReferee)}
              >
                {proposalReferee.proposalName}
              </TableCell>
              <TableCell>{proposalReferee.proposalTitle}</TableCell>
              <TableCell>{proposalReferee.proposalProgramtypeName}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
